import { ImageSizeControls } from './image-size-controls.js';
import { ImageControls } from './image-controls.js';


export function ImageObjectFactory (pEditor, pImage)
{
  const imageObjectsList = [],
        imageObjectTypes =
        {
          'TYPE_IMAGE': 10,
          'TYPE_ARTTEXT': 20,
          'TYPE_ANCHOR': 30
        };

  let isMouseOverImageElement = false,
      imageSizeControls;


  this.reInit = () =>
  {
    imageObjectsList.splice(0, imageObjectsList.length);
  };


  this.checkAllImages = () =>
  {
    let img = pEditor.iFrameDoc.getElementsByTagName('IMG');

    for (let i = 0; i < imageObjectsList.length; i++)
    {
      imageObjectsList[i].isInited = false;
    }

    for (let i = 0; i < img.length; i++)
    {
      if ((!img[i].getAttribute('alt', 0) || (img[i].getAttribute('alt', 0)).indexOf('UserCustomScript-') === -1) && !img[i].getAttribute('data-WaComponentType', 0))
      {
        createImageObject(img[i], (pEditor.artText.isArtTextImage(img[i]) ? imageObjectTypes.TYPE_ARTTEXT : (img[i].getAttribute('data-anchorIndex') ? imageObjectTypes.TYPE_ANCHOR : imageObjectTypes.TYPE_IMAGE)));
      }
    }

    for (let i = 0; i < imageObjectsList.length; i++)
    {
      if (!imageObjectsList[i].isInited && imageObjectsList[i].dispose && typeof(imageObjectsList[i].dispose) === 'function')
      {
        try
        {
          imageObjectsList[i].dispose();
          delete imageObjectsList[i];
          imageObjectsList.splice(i, 1);
        }
        catch (err) {}
      }
    }
  };


  const getImageObject = imageElement =>
  {
    for (let i = imageObjectsList.length; i--;)
    {
      if (imageObjectsList[i].element === imageElement)
      {
        return imageObjectsList[i];
      }
    }

    return null;
  };
  

  function createImageObject (imageElement, imageType)
  {
    let i,
        imageObject = getImageObject(imageElement);

    if (imageObject)
    {
      imageObject.object.reInit();
      imageObject.isInited = true;
      return imageObject.object;
    }

    i = imageObjectsList.length;

    imageObjectsList[i] =
    {
      'element': imageElement,
      'type': imageType,
      'object': new ImageObject(pEditor.pThis),
      'isInited': false
    };

    imageObjectsList[i].object.init(imageElement);
    imageObjectsList[i].isInited = true;

    return imageObjectsList[i].object;


    function ImageObject (psThis)
    {
      this.isObjValid = false;
      const pThis = this;

      pThis.init = init;
      pThis.reInit = reInit;
      pThis.mouseOver = showControls;
      pThis.mouseOut = hideControls;
      pThis.click = imageClick;
      pThis.select = setImageSelection;
      pThis.controlsCommand = controlsCommand;
      pThis.dispose = dispose;

      let imageElement,
          linkElement,
          checkImageElementTM,
          isImageClicked = false,
          imageClickTM = null,
          onKeyDownTM = null;

      if (!imageSizeControls)
      {
        imageSizeControls = new ImageSizeControls(pEditor, pImage);
      }

      pEditor.pThis.addHandler('unreged', deselectImage, 'DeselectImageElementOnBlur');


      function init (initImageElement)
      {
        imageElement = initImageElement;

        if (imageElement)
        {
          pImage.controls = (pImage.controls) ? pImage.controls : new ImageControls(pEditor, pImage);
          addImageHandlers();
        }
      }


      function reInit ()
      {
        if (imageElement)
        {

          addImageHandlers();
        }
      }


      function addImageHandlers ()
      {
        BEditor.domHandlers.addHandler(imageElement, 'mouseover', showControls);
        BEditor.domHandlers.addHandler(imageElement, 'mouseout', hideControls);
        BEditor.domHandlers.addHandler(imageElement, 'click', imageClick);
      }


      function showControls ()
      {
        if (imageSizeControls.isSelMoving)
        {
          return true;
        }

        pImage.controls.stopHidingControls();

        isMouseOverImageElement = true;
        linkElement = imageElement.parentNode;

        if (linkElement && linkElement.nodeName.toUpperCase() !== 'A')
        {
          linkElement = null;
        }

        pImage.controls.showControls(pThis, imageElement, imageType, linkElement);
        if (checkImageElementTM) clearInterval(checkImageElementTM);
        checkImageElementTM = setInterval(checkImageElement, 37);
      }


      function hideControls ()
      {
        isMouseOverImageElement = false;
        if (checkImageElementTM) clearInterval(checkImageElementTM);
        pImage.controls.hideControls();
      }


      function imageClick (e, isRestoreRange)
      {
        if (imageClickTM) clearTimeout(imageClickTM);

        if (isImageClicked && !isRestoreRange)
        {
          isImageClicked = false;
          controlsCommand('Settings');
        }
        else
        {
          setImageSelection(!!BEditor.browser.isWebKit);

          if (e && !isRestoreRange)
          {
            isImageClicked = true;
            imageClickTM = setTimeout(clearImageClick, 373);
          }
          else
          {
            isImageClicked = false;
          }
        }
      }


      function clearImageClick ()
      {
        if (imageClickTM) clearTimeout(imageClickTM);
        isImageClicked = false;
      }


      function checkImageElement ()
      {
        if (!imageElement || !imageElement.parentNode)
        {
          hideControls();

          if (imageElement)
          {
            BEditor.domHandlers.removeHandler(imageElement, 'mouseout', hideControls);
          }
        }
      }


      function controlsCommand (command)
      {
        const pButton = pEditor.pToolbar.getButtonByName(((imageType === imageObjectTypes.TYPE_ARTTEXT) ? 'ArtText' : ((imageType === imageObjectTypes.TYPE_ANCHOR) ? 'InsertLinkAndAnchor' : 'InsertPicture')));

        switch (command)
        {
          case 'Unlink':
            setImageSelection(true);
            pEditor.link.remover.removeLink(pEditor.pToolbar.getButtonByName('InsertLinkAndAnchor'));
            psThis.focus();
            showControls();
            break;

          case 'Delete':
            hideControls();
            deleteImage();
            psThis.focus();
            break;

          case 'Link':
            setImageSelection(true);
            pEditor.link.inserter.openInsertLinkDialog(pEditor.pToolbar.getButtonByName('InsertLinkAndAnchor'));
            break;

          case 'Settings':
            setImageSelection(true);
            psThis.execCommand(pButton, ((imageType === imageObjectTypes.TYPE_ARTTEXT) ? 'openInsertArtTextDialog' : ((imageType === imageObjectTypes.TYPE_ANCHOR) ? 'openInsertAnchorDialog' : 'showImageSettingsToolBar')));
            break;
        }
      }


      function setImageSelection (isForced)
      {
        let objSelection,
            objRange;

        if (!imageElement || !imageElement.parentNode)
        {
          hideControls();
          BEditor.domHandlers.removeHandler(imageElement, 'mouseout', hideControls);
          return;
        }

        if (isForced)
        {
          if (BEditor.browser.isIE)
          {
            objRange =  pEditor.iFrameDoc.body.createControlRange();

            if (objRange)
            {
              for (let i = 0; i < objRange.length; i++)
              {
                objRange.remove(i);
              }

              objRange.addElement(imageElement);
              objRange.select();
              pImage.currentImage = imageElement;
            }
          }
          else
          {
            objSelection =  pEditor.iFrame.getSelection();

            if (objSelection)
            {
              if (BEditor.browser.isWebKit && String(BEditor.styleHelpers.getElementStyle(imageElement, 'position', pEditor.iFrame)).toLowerCase() === 'absolute')
              {
                pEditor.setEnabledCommand(false,
                {
                  exclude:
                  {
                    undo: true,
                    redo: true,
                    cut: true,
                    copy: true,
                    paste: true,
                    openPageLayoutsDropdown: true,
                    openInsertImageDialog: true,
                    openLinkDropdown: true,
                    openInsertLinkDialog: true,
                    removeLink: true,
                    openInsertLinkToAnchorDialog: true,
                    setAnchorsVisibility: true,
                    openInsertDocumentDialog: true,
                    showHideTablesBorders: true,
                    openLayerDropdown: true,
                    setPositionAbsolute: true,
                    setZIndexForward: true,
                    setZIndexBack: true,
                    horizontalAlignLeftLayer: true,
                    horizontalAlignCenterLayer: true,
                    horizontalAlignRightLayer: true,
                    verticalAlignTopLayer: true,
                    verticalAlignMiddleLayer: true,
                    verticalAlignBottomLayer: true,
                    openInsertArtTextDialog: true,
                    cleanupHTML: true,
                    openEditHTMLDialog: true,
                    openSpellChecker: true
                  }
                });

                pImage.webkitSelectedImage = imageElement;
                pEditor.absImageSelected = imageElement;
                pEditor.range.cursor.hide();
              }
              else
              {
                objSelection.removeAllRanges();
                objSelection.selectAllChildren(imageElement);
                objSelection.removeAllRanges();
                objRange = pEditor.iFrameDoc.createRange();
                objRange.selectNode(imageElement);
                objSelection.addRange(objRange);
                pImage.currentImage = imageElement;

                if (BEditor.browser.isWebKit)
                {
                  imageSizeControls.select(imageElement);
                }
              }

              if (BEditor.browser.isWebKit)
              {
                pEditor.range.save();
              }
            }
          }
        }

        BEditor.domHandlers.addHandler(pEditor.iFrameDoc, 'mousedown', deselectImage);
        BEditor.domHandlers.addHandler(pEditor.iFrameDoc, 'keydown', onKeyDown);

        setTimeout(checkSelectedImage, 100);

        if (pEditor.pToolbar)
        {
          pEditor.pToolbar.refreshState();
        }
      }


      function checkSelectedImage ()
      {
        try
        {
          if (!imageElement || !imageElement.parentNode)
          {
            deselectImage();
            BEditor.domHandlers.removeHandler(imageElement, 'mouseout', hideControls);
          }
          else
          {
            setTimeout(checkSelectedImage, 100);
          }
        }
        catch (e) {}
      }


      function onKeyDown ()
      {
        if (onKeyDownTM) clearTimeout(onKeyDownTM);
        onKeyDownTM = setTimeout(onKeyDownDo, 30);
      }


      function onKeyDownDo ()
      {
        const currentImageElement = pImage.getCurrentImage();

        if (!currentImageElement || currentImageElement !== imageElement)
        {
          deselectImage();
        }
      }


      function deselectImage (e)
      {
        if (!e || !e.target || !imageElement || e.target !== imageElement)
        {
          hideControls();

          if (BEditor.browser.isWebKit)
          {
            imageSizeControls.deselect();
          }

          BEditor.domHandlers.removeHandler(pEditor.iFrameDoc, 'keydown', onKeyDown);

          if (pEditor.pToolbar)
          {
            pEditor.pToolbar.refreshState();
          }
        }
      }


      function deleteImage ()
      {
        let parentElement;

        BEditor.domHandlers.removeHandler(imageElement, 'mouseout', hideControls);

        parentElement = imageElement.parentNode;

        if (parentElement)
        {
          parentElement.removeChild(imageElement);

          if (parentElement.innerHTML === '')
          {
            if (parentElement.nodeName === 'P')
            {
              parentElement.innerHTML = '<BR>';
            }
            else if (parentElement.nodeName === 'A')
            {
              parentElement.parentNode.removeChild(parentElement);
            }
          }
        }
      }


      function dispose ()
      {
        if (checkImageElementTM) clearInterval(checkImageElementTM);

        if (imageElement)
        {
          BEditor.domHandlers.removeHandler(imageElement, 'mouseout', hideControls);
        }
      }
    }

  }


  this.getImageObject = getImageObject;

  Object.defineProperty(this, 'imageObjectTypes', { get: () => imageObjectTypes });
  Object.defineProperty(this, 'isMouseOverImageElement', { get: () => isMouseOverImageElement });
}